export async function backlogShowFFDetailsUseCase(client_name, cod_type, ff_type, backlogRepository) {

    const result = await backlogRepository.backlog_show_ff_details(client_name, cod_type, ff_type);

    // const entity = new backlogRepository.model_fulfillment(result.data.success.arguments)

    // if (!entity.isValid()) {
    //     console.log(entity)
    //     throw new Error("Backlog fulfillment response invalido");
    // }

    return result.data.success.arguments;
}